export const ORDINARY_ORDER_PERMISSION_GROUP = '__ordinary__';

export const ORDER_PERMISSION_GROUP_OPTIONS = [
  { value: ORDINARY_ORDER_PERMISSION_GROUP, label: '普通产品' },
  { value: 'youxiang', label: '优享计划' },
  { value: 'inservice_degree', label: '在职学历提升' },
  { value: 'qihang', label: '启航' },
  { value: 'employment_1v1', label: '1V1就业辅导' },
];

const RESTRICTED_ORDER_ACTIONS = [
  'create-restricted-order',
  'manage-restricted-orders',
  'approve-restricted-orders',
];

function hasRestrictedProductScope(permissionScopes) {
  return !!permissionScopes?.sales?.['restricted-order-product-access']?.some?.(
    ({ scope }) =>
      scope?.name === 'orderProduct_youxang' ||
      scope?.name === 'orderProduct_inservice_degree' ||
      scope?.name === 'orderProduct_qihang' ||
      scope?.name === 'orderProduct_employment_1v1',
  );
}

export function getRestrictedOrderAccess({
  permissions = {},
  permissionScopes = {},
  canSeeAllSalesPage = false,
  canFollowOrder = false,
  hasLegacyContractAccess = false,

}) {
  const salesPermissions = permissions.sales || [];
  const hasProductScope = hasRestrictedProductScope(permissionScopes);
  const isRestrictedActor = RESTRICTED_ORDER_ACTIONS.some((action) =>
    salesPermissions.includes(action),
  );
  const canCreateRestrictedOrder =
    hasProductScope && salesPermissions.includes('create-restricted-order');
  const canManageRestrictedOrders =
    hasProductScope && salesPermissions.includes('manage-restricted-orders');
  const canUseLegacyOrderFeatures = canSeeAllSalesPage || canFollowOrder;
  const canUseLegacyContractFeatures = hasLegacyContractAccess;

  return {
    canCreateRestrictedOrder,
    canUseLegacyOrderFeatures,
    canUseLegacyContractFeatures,
    canAccessSalesLeads: canSeeAllSalesPage || salesPermissions.includes('manage-own-sales-leads'),
    canViewSalableProducts: !!permissions.product?.includes('query'),
    canAccessSalesCustomers: canSeeAllSalesPage || canCreateRestrictedOrder,
    canCreateSalesOrder: canSeeAllSalesPage || canFollowOrder || canCreateRestrictedOrder,
    canQueryOrders:
      canSeeAllSalesPage ||
      canFollowOrder ||
      salesPermissions.includes('query-orders') ||
      canCreateRestrictedOrder ||
      canManageRestrictedOrders,
    canContract:
      canUseLegacyContractFeatures ||
      (isRestrictedActor && hasProductScope && !!permissions.contract?.includes('query')),
  };
}

export function serializeOrderPermissionGroup(value) {
  return value == null || value === ORDINARY_ORDER_PERMISSION_GROUP ? null : value;
}

export function deserializeOrderPermissionGroup(value) {
  return value ?? ORDINARY_ORDER_PERMISSION_GROUP;
}

export function getRestrictedProductTableLocale({
  canCreateRestrictedOrder,
  consultant,
  isQianTu,
}) {
  if (!canCreateRestrictedOrder) {
    return undefined;
  }

  return {
    emptyText: !consultant
      ? '请先选择顾问'
      : isQianTu
        ? '请输入BM合同名称后点击查询'
        : '暂无符合条件的可售产品，请调整查询条件',
  };
}

export function shouldQueryUpgradableContracts({
  canCreateRestrictedOrder,
  canUseLegacyContractFeatures,
}) {
  return canUseLegacyContractFeatures || !canCreateRestrictedOrder;
}

export function shouldQueryQiantuNotTransfer({
  canCreateRestrictedOrder,
  canUseLegacyOrderFeatures,
}) {
  return canUseLegacyOrderFeatures || !canCreateRestrictedOrder;
}
